export default __webpack_public_path__ + "static/O0084-aef868f3bbc482d095828686da346082.png";